import { createContext } from "react";

export const DefaultValuesContext = createContext({});
